import { Skeleton as MuiSkeleton } from '@mui/material'
import { SxProps, useTheme } from '@mui/material/styles'

export const ImageSkeleton = ({
  width,
  height,
  className,
  color,
  sx,
}: {
  width?: string | number
  height?: string | number
  className?: string
  color?: string
  sx?: SxProps
}) => {
  const theme = useTheme()

  return (
    <MuiSkeleton
      className={className}
      animation="wave"
      variant="rounded"
      width={width}
      height={height}
      sx={{ backgroundColor: color ? color : theme.palette.background.light, ...sx }}
    />
  )
}
